<template>
  <div class="page-shell page-shell--role-manage">
    <section class="page-shell__content">
      <div class="page-shell__grid role_manage_main">
      <div v-loading="roleLoading" class="page-shell__panel role_list">
        <el-button
          type="primary"
          v-permit="'Enterprise.Role.Create'"
          @click="addNewRole"
          >新建角色</el-button
        >
        <div
          class="role_item"
          v-for="item in allRoleList"
          :key="item.roleID"
          :class="item.roleID == curSelectedRoleId ? 'role_item_selected' : ''"
        >
          <div class="role_name" @click="selectRole(item)">
            {{ item.roleName }}
          </div>
          <el-dropdown trigger="click" @command="roleHandleClick">
            <span class="el-dropdown-link">
              <i
                class="el-icon-arrow-down el-icon--right"
                @click="roleDropdownClick(item)"
              ></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-permit="'Enterprise.Role.Update'"
                command="modify"
                >修改</el-dropdown-item
              >
              <el-dropdown-item
                v-permit="'Enterprise.Role.Delete'"
                v-if="!item.isAdmin"
                command="delete"
                >删除</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="page-shell__panel page-shell__tabs role_operate">
        <el-tabs v-model="activeName" @tab-click="tabsChange" class="customTabs" type="border-card">
          <el-tab-pane
            label="角色员工"
            v-if="havePerm('Enterprise.Role.Staff.List')"
            name="user"
          >
            <div class="page-shell__tab-pane role_operate_table">
              <public-table
                v-loading="userLoading"
                :column="userColumn"
                :tableData="roleUsers"
                :onAdd="() => (addUserToRoleShow = true)"
                addPerm="Enterprise.Role.Staff.GrantUsers"
                :PageInfo="listRoleUserQuery"
                @handlePaginationChange="getUserFormRole"
              >
                <template v-slot:userID="{ row }">
                  <el-button
                    size="mini"
                    type="text"
                    v-permit="'Enterprise.Role.Staff.Reclaim'"
                    @click="handleDelete(row)"
                    >删除</el-button
                  >
                </template>
              </public-table>
            </div>
          </el-tab-pane>
          <el-tab-pane
            label="角色权限"
            v-permit="'Enterprise.Role.Permission.List'"
            name="perm"
          >
            <div class="page-shell__tab-pane">
              <el-alert
                v-if="!enableEditPerm"
                type="success"
                title="默认企业管理员角色包含所有权限，不能修改"
              />
              <div v-loading="permLoading" class="role_permission_box">
                <el-button
                  v-if="enableEditPerm"
                  type="primary"
                  v-permit="'Enterprise.Role.Permission.Update'"
                  @click="saveRolePermission"
                  >保存</el-button
                >
                <el-tabs v-model="subActiveName" @tab-click="subTabsChange">
                  <el-tab-pane label="权限管理" name="sub-first">
                    <div class="permissions_content_checkbox">
                      <el-tree
                        :render-content="renderContent"
                        :data="allPermissionsList"
                        ref="permissionTree"
                        :indent="0"
                        :expand-on-click-node="false"
                        :props="defaultProps"
                        show-checkbox
                        node-key="resource"
                        empty-text
                        default-expand-all
                      />
                    </div>
                  </el-tab-pane>
                </el-tabs>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 角色编辑 -->
    <el-dialog
      :title="roleDialogTitle"
      :visible.sync="showRoleDialog"
      width="30%"
    >
      <el-form
        ref="dialogRef"
        :inline="true"
        :model="roleInfo"
        :rules="dialogRules"
        class="new-dialog-form"
        label-width="80px"
      >
        <el-row>
          <el-form-item label="角色名称" prop="roleName">
            <el-input
              class="w255"
              v-model.trim="roleInfo.roleName"
              placeholder="请输入角色名称"
            ></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="roleDialogSubmit">确 定</el-button>
        <el-button @click="roleDialogClose">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 添加用户到角色 -->
    <add-user
      :eid="eid"
      :dialogVisible="addUserToRoleShow"
      :onClose="closeAddUserToRoleShow"
      :onSuccess="closeAddUserToRoleShow"
      :roleID="curSelectedRoleId"
    ></add-user>
    </section>
  </div>
</template>
<script>
import {
  addNewRoleApi,
  deleteUserFormRoleApi,
  delteRoleApi,
  getAllPermissionsApi,
  getAllRoleApi,
  getPermissionsByRoleApi,
  getUserFormRoleApi,
  modifyRoleApi,
  modifyRolePermissionApi
} from '@/api/enterpriseManage';
import { havePerm } from '../../../utils/auth';
import { errorHandle } from '../../../utils/error';
import addUserToRole from './components/addUserToRole';
export default {
  data() {
    return {
      dialogRules: {
        roleName: [
          { required: true, message: '角色名称不能为空', trigger: 'blur' },
          { max: 255, message: '最大255个字符', trigger: 'blur' }
        ]
      },
      havePerm,
      activeName: havePerm('Enterprise.Role.Staff.List') ? 'user' : 'perm',
      subActiveName: 'sub-first',
      // 是否全选，控制样式
      isIndeterminate: false,
      // 全选标识
      checkAll: false,
      // 所有权限
      allData: [],
      roleLoading: true,
      // 所有角色
      allRoleList: [],
      curHandleRole: null,
      curSelectedRoleId: '',
      allPermissionsList: [],
      enableEditPerm: true,
      defaultProps: {
        children: 'perms',
        label: 'cnName'
      },
      // 角色新增修改
      isAddNewRole: true,
      roleDialogTitle: '新建角色',
      roleInfo: {},
      showRoleDialog: false,
      listRoleUserQuery: {
        page: 1,
        pageSize: 10,
        total: 0
      },
      listQuery: {},
      roleUsers: [],
      userLoading: true,
      addUserToRoleShow: false,
      userColumn: [
        { prop: 'userName', label: '用户名' },
        { prop: 'realName', label: '姓名' },
        { prop: 'orgName', label: '组织机构' },
        { prop: 'roles', label: '角色' },
        { prop: 'userID', label: '操作', scopeStatus: true }
      ],
      permLoading: true
    };
  },
  components: { 'add-user': addUserToRole },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    eid() {
      return this.userInfo.eid;
    }
  },
  created() {
    if (this.userInfo.eid) {
      this.initData();
    } else {
      setTimeout(() => {
        this.initData();
      }, 1200);
    }
  },
  mounted() {
    this.changeCss();
  },
  // 监听事件
  watch: {
    // dataList的值改变后会执行
    allPermissionsList(newData, oldData) {
      // 使用$nextTick方法
      this.$nextTick(() => {
        this.changeCss();
      });
    }
  },

  methods: {
    initData() {
      this.getAllRole();
      this.getAllPermissions();
    },
    renderContent(h, { node, data, store }) {
      let classname = '';
      if (
        (node.level === 4 || node.level === 3 || node.level === 2) &&
        node.childNodes.length != 0
      ) {
        classname = 'wraps';
      }
      return h(
        'span',
        {
          class: classname
        },
        node.label
      );
    },
    changeCss() {
      const levelName = document.getElementsByClassName('wraps');
      for (let i = 0; i < levelName.length; i++) {
        levelName[i].parentNode.style.width = 'calc(100vw - 650px)';
      }
    },
    // 标签切换
    tabsChange() {
      if (this.curSelectedRoleId) this.getPermissionsByRole();
    },
    subTabsChange() {},
    // 根据角色获取权限
    getPermissionsByRole() {
      this.permLoading = true;
      getPermissionsByRoleApi({
        eid: this.userInfo.eid,
        roleID: this.curSelectedRoleId
      })
        .then((res) => {
          if (res.permissions && this.$refs.permissionTree) {
            this.$refs.permissionTree.setCheckedKeys(res.permissions);
          }
          this.permLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.permLoading = false;
        });
    },
    // 获取所有角色
    getAllRole() {
      this.roleLoading = true;
      getAllRoleApi({
        eid: this.userInfo.eid
      })
        .then((res) => {
          this.allRoleList = res.roles;
          if (!this.curSelectedRoleId) {
            this.curSelectedRoleId = this.allRoleList[0].roleID;
            this.enableEditPerm = !this.allRoleList[0].isAdmin;
          }
          this.roleLoading = false;
          this.getUserFormRole();
          this.getPermissionsByRole();
        })
        .catch((err) => {});
    },
    // 选择角色
    selectRole(item) {
      this.listRoleUserQuery = {
        page: 1,
        pageSize: 10,
        total: 0
      }
      this.curSelectedRoleId = item.roleID;
      this.enableEditPerm = !item.isAdmin;
      if (this.$refs.permissionTree) {
        this.$refs.permissionTree.setCheckedKeys([]);
      }
      this.getPermissionsByRole();
      this.getUserFormRole();
    },
    // 角色操作点击
    roleHandleClick(cmd) {
      if (cmd == 'modify') {
        this.isAddNewRole = false;
        this.roleInfo = JSON.parse(JSON.stringify(this.curHandleRole));
        this.showRoleDialog = true;
        this.roleDialogTitle = '修改角色';
        this.$nextTick(() => {
          this.$refs.dialogRef.clearValidate();
        });
      } else {
        this.delteRole();
      }
    },
    // 角色操作
    roleDropdownClick(role) {
      this.curHandleRole = role;
    },
    // 获取所有权限
    getAllPermissions() {
      getAllPermissionsApi({
        eid: this.userInfo.eid
      }).then((res) => {
        this.allPermissionsList = [
          { resource: '', cnName: '全部', perms: res }
        ];
      });
    },

    // 添加角色
    addNewRole() {
      this.isAddNewRole = true;
      this.roleInfo = {};
      this.showRoleDialog = true;
      this.roleDialogTitle = '新建角色';
      this.$nextTick(() => {
        this.$refs.dialogRef.clearValidate();
      });
    },
    // 角色保存
    roleDialogSubmit() {
      this.$refs.dialogRef.validate((valid) => {
        if (valid) {
          if (this.isAddNewRole) {
            // 新增
            addNewRoleApi({
              eid: this.userInfo.eid,
              name: this.roleInfo.roleName
            })
              .then((res) => {
                this.getAllRole();
                this.showRoleDialog = false;
                this.$message.success('操作成功');
              })
              .catch((err) => {
                errorHandle(err);
              });
          } else {
            // 修改
            modifyRoleApi({
              eid: this.userInfo.eid,
              roleID: this.curHandleRole.roleID,
              name: this.roleInfo.roleName
            })
              .then((res) => {
                this.getAllRole();
                this.showRoleDialog = false;
                this.$message.success('操作成功');
              })
              .catch((err) => {
                errorHandle(err);
              });
          }
        }
      });
    },
    // 关闭
    roleDialogClose() {
      this.showRoleDialog = false;
    },
    // 删除角色
    delteRole() {
      this.$confirm('确认继续执行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        delteRoleApi({
          eid: this.userInfo.eid,
          roleID: this.curHandleRole.roleID
        })
          .then((res) => {
            if (this.allRoleList && this.allRoleList.length > 0) {
              this.curHandleRole = this.allRoleList[0];
              this.curSelectedRoleId = this.allRoleList[0].roleID;
              this.enableEditPerm = !this.allRoleList[0].isAdmin;
            }
            this.getAllRole();
            this.$message.success('删除成功');
          })
          .catch((err) => {
            errorHandle(err);
          });
      });
    },
    // 保存权限
    saveRolePermission() {
      const ids = this.$refs.permissionTree.getCheckedKeys();
      const data = [];
      ids.forEach((item) => {
        if (item.indexOf('resource_') == -1) {
          data.push(item);
        }
      });
      modifyRolePermissionApi({
        eid: this.userInfo.eid,
        roleID: this.curSelectedRoleId,
        permissions: data
      })
        .then((res) => {
          this.$message.success('操作成功');
          this.$store.dispatch('GetUserAuthList');
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    // 根据角色获取用户
    getUserFormRole(parameter) {
      if (!havePerm('Enterprise.Role.Staff.List')) {
        return;
      }
      if (parameter) {
        this.listQuery = Object.assign(this.listRoleUserQuery, parameter);
      }
      this.userLoading = true;
      getUserFormRoleApi({
        eid: this.userInfo.eid,
        roleID: this.curSelectedRoleId,
        page: this.listRoleUserQuery.page,
        pageSize: this.listRoleUserQuery.pageSize
      })
        .then((res) => {
          if (res.users && res.users.length > 0) {
            res.users.forEach((item) => {
              if (item.roles) {
                item.roles = item.roles.join();
              }
            });
            this.listRoleUserQuery.total = res.total;
            this.roleUsers = res.users;
          } else {
            this.roleUsers = [];
          }
          this.userLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.userLoading = false;
        });
    },
    // 删除
    handleDelete(row) {
      this.$confirm('确认要删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteUserFormRoleApi({
            eid: this.userInfo.eid,
            roleID: this.curSelectedRoleId,
            userID: row.userID
          })
            .then((res) => {
              this.getUserFormRole();
              this.$message.success('删除成功');
            })
            .catch((err) => {
              errorHandle(err);
            });
        })
        .catch((err) => {});
    },
    closeAddUserToRoleShow() {
      this.addUserToRoleShow = false;
      this.getUserFormRole();
    }
  }
};
</script>
<style scoped lang="scss">
@import 'src/styles/page-shell.scss';

.role_manage_main {
  grid-template-columns: 220px minmax(0, 1fr);
}

.role_list {
  padding: 18px 0 12px;
}

.role_list button {
  margin: 0 18px 18px;
  font-size: 14px;
  color: #fff;
  padding: 10px 20px;
}

.role_item {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}

.role_item .role_name {
  padding: 16px;
  width: 150px;
}

.role_item .el-dropdown {
  padding: 16px;
  display: none;
}

.role_item:hover {
  background: #ebf3ff;
  border-right: 2px solid #46cdcf;
}

.role_item:hover .el-dropdown {
  display: block;
}

.role_item_selected {
  background: #ebf3ff;
}

.role_operate {
  padding-bottom: 18px;
}

::v-deep .permissions_content_checkbox .el-tree .el-tree-node > .el-tree-node__content {
  margin-bottom: 20px;
  min-width: 160px;
}

::v-deep .permissions_content_checkbox .el-tree .el-tree-node__children {
  padding-left: 10px;
}

::v-deep .permissions_content_checkbox .el-tree-node__children .el-tree-node__children {
  display: flex;
  flex-wrap: wrap;
}

.checkbox_wrap {
  margin-bottom: 20px;
}

.role_permission_box {
  position: relative;
}

.role_permission_box button {
  margin-bottom: 16px;
}
/* 表格 */
::v-deep .role_operate_table .el-table thead th {
  background-color: #f2f2f2;
  font-weight: 400;
  font-size: 13px;
}

::v-deep .role_operate_table .table-head-name {
  color: #909399;
  font-size: 13px;
  line-height: 23px;
  padding: 0;
}

::v-deep .role_operate_table .el-table thead .cell {
  height: 23px;
}

::v-deep .role_operate_table .el-table tbody tr td {
  font-size: 13px;
}

@media (max-width: 1080px) {
  .role_manage_main {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/information/roleManage/index.vue